module.exports = __webpack_public_path__ + "aa9bfba32c0c21d7a82cef22a9665c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/pinterest.png
// module id = 1307
// module chunks = 47